import { setupEventHandlers } from "./lib/domHelpers.js"

class JUDEWidgetElement extends HTMLElement {
  static {
    customElements.define("jude-widget", this)
  }

  menuHideDelay = 300

  connectedCallback() {
    setupEventHandlers(this, ["mouseenter", "mouseleave", "jude-widget-menu-action"])
  }

  get uuid() {
    return this.getAttribute("jude-uuid")
  }

  handleEvent(event) {
    if (event.type === "mouseenter") {
      clearTimeout(this.delayedHide)
      if (!this.querySelector("jude-widget-menu")) {
        const widgetMenu = document.createElement("jude-widget-menu")
        this.addMenuItems(widgetMenu)
        this.prepend(widgetMenu)
      }
    } else if (event.type === "mouseleave") {
      this.delayedHide = setTimeout(
        () => this.querySelector("jude-widget-menu")?.remove(),
        this.menuHideDelay,
      )
    } else if (event.type === "jude-widget-menu-action") {
      this.takeAction(event.detail.action)
    }
  }

  addMenuItems(widgetMenu) {
    widgetMenu.addItem("settings", "Settings…")
    widgetMenu.addItem("copy-as-markdown", "Copy as Markdown…")
    widgetMenu.addItem("archive", "Archive Widget")
  }

  takeAction(action) {
    switch (action) {
      case "settings":
        alert("TODO…")
        break
      case "copy-as-markdown":
        htmx.ajax("GET", "/widgets/markdown", { swap: "streetcar", values: { uuid: this.uuid } })
        break
      case "archive":
        htmx.ajax("POST", "/widgets/archive", { swap: "streetcar", values: { uuid: this.uuid } })
        document.startViewTransition(() => this.remove())
        break
    }
  }
}

class JUDEWidgetMenu extends HTMLElement {
  static {
    customElements.define("jude-widget-menu", this)
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        @scope {
          :scope {
            display: block;
            position: absolute;
            z-index: 99;
            margin-block-start: calc(0rem - var(--wa-space-xs));
            margin-inline-start: calc(2px - var(--wa-space-xl));
          }

          wa-button {
            opacity: 0.33;
          }

          wa-button::part(button) {
           --wa-form-control-height: var(--wa-space-l);
           padding-inline: 0;
          }
        }
      </style>
      <wa-dropdown placement="top">
        <wa-button appearance="accent" variant="neutral" slot="trigger" size="s">
          <wa-icon name="dots-three-vertical"></wa-icon>
        </wa-button>

        ${this.items
          .map((item) => {
            return `<wa-dropdown-item value="${item.value}">${item.label}</wa-dropdown-item>`
          })
          .join("")}
      </wa-dropdown>
    `

    this.addEventListener("wa-select", this)
  }

  addItem(value, label) {
    this.items ??= []
    this.items.push({ value, label })
  }

  handleEvent(event) {
    if (event.type === "wa-select") {
      const action = event.detail.item.value
      this.dispatchEvent(
        new CustomEvent("jude-widget-menu-action", { bubbles: true, detail: { action } }),
      )
    }
  }
}
